import { call, put, takeLatest } from 'redux-saga/effects';
import { GET_SPECIAL_EVENT_ITEM_AVAILABILITY, GET_SPECIAL_EVENT_ITEM_AVAILABILITY_SUCCESS, GET_SPECIAL_EVENT_ITEM_AVAILABILITY_ERROR, } from '../constants';
import networkConfig from '../network/config';
import invokeApi from '../network';
import SpecialEventUtils from '../utils/SpecialEventUtils';
/**
 * getSpecialEventItemAvailability - Checks overall item availability for products sold during special events
 *
 * @param {Object} specialEventData - {
 *  type: Called ACTION type,
 *  storeId: String,
 *  selectedDate: Number, Customer's selected date in epoch format Exp: 1686597712
 *  selectedTime: String, Customer's currently selected time Exp: "0900"
 * }
 *
 */
export function* getSpecialEventItemAvailability(specialEventData) {
    try {
        const specialEventItemConfig = networkConfig.specialEventItemAvailability;
        const specialEventItemData = {
            queryProps: {
                storeId: specialEventData.storeId,
                date: specialEventData.selectedDate,
            },
        };
        const apiCallHandler = invokeApi;
        const response = yield call(apiCallHandler, specialEventItemConfig, specialEventItemData);
        if (response?.response) {
            const parsedResponse = JSON.parse(JSON.stringify(response.response));
            const parsedItemsArray = SpecialEventUtils.getSpecialEventItems(parsedResponse, specialEventData.selectedTime);
            yield put({
                type: GET_SPECIAL_EVENT_ITEM_AVAILABILITY_SUCCESS,
                response: parsedItemsArray,
            });
        }
        else {
            yield put({
                type: GET_SPECIAL_EVENT_ITEM_AVAILABILITY_ERROR,
            });
        }
    }
    catch (error) {
        yield put({
            type: GET_SPECIAL_EVENT_ITEM_AVAILABILITY_ERROR,
        });
    }
}
export default function* specialEventSaga() {
    yield takeLatest(GET_SPECIAL_EVENT_ITEM_AVAILABILITY, getSpecialEventItemAvailability);
}
